import { ThemeProps, Divider, MediaQueries } from '@hhgtech/hhg-components'
import { VideoList } from 'components/organisms/videoLists'
import { Z_INDEX } from 'interfaces/constants'
import styled, { css } from 'styled-components'

const TableStyle = css`
  table th:first-child {
    border-radius: 8px 0 0 0;
  }
  table th:last-child {
    border-radius: 0 8px 0 0;
  }

  table {
    border-collapse: collapse;
    display: block;
    width: 100%;
    border-spacing: 0;
    margin-block: 10px;
    font-family: Inter, san-serif;
    min-width: 375px;
    max-width: 700px;
    overflow-x: auto;
    thead,
    tbody {
      width: 100%;
    }
    th,
    td {
      min-width: 300px;
      width: 160px;
      padding: 13px 12px;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: -0.2px;
      font-style: normal;
      text-align: left;
      ${MediaQueries.mbDown} {
        min-width: 187.5px;
      }
      p:last-child {
        margin-bottom: 0;
      }
    }
    th {
      font-weight: 600;
    }
    td {
      font-weight: 400;
    }
    &.spine-table-light {
      thead {
        background-color: #f3f3f3;
        th {
          color: #3e3f58;
        }
      }
      tbody {
        td {
          border-bottom: 1px solid #f3f3f3;
        }
      }
    }
    &.spine-table-dark {
      thead {
        background-color: #9495a0;
        th {
          color: #fdfdfd;
        }
      }
      tbody {
        tr {
          background-color: #fdfdfd;
        }
        tr:nth-child(even) {
          background-color: #f3f3f3;
        }
      }
    }
    &.spine-table-blue {
      thead {
        background-color: #b6cdff;
        th {
          color: #ffffff;
        }
      }
      tbody {
        tr {
          background-color: #eff4fe;
          border-bottom: 1px solid #e0e9fb;
          color: #202135;
        }
      }
    }
    &.spine-table-pros-cons {
      display: inline-table;
      thead {
        th {
          text-align: center;
          color: #ffffff;
          &:nth-child(2n + 1) {
            background-color: #b6cdff;
          }
          &:nth-child(2n) {
            background-color: #ffaaa9;
          }
        }
      }
      tbody {
        td {
          color: #202135;
          &::before {
            content: '•';
            margin-right: 4px;
          }
          &:nth-child(2n + 1) {
            background-color: #eff4fe;
          }
          &:nth-child(2n) {
            background-color: #ffeaf1;
          }
        }
      }
    }
  }
`

export const StyledArticleContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  ${MediaQueries.mbUp} {
    width: calc(100% + var(--author-width) + 3em);
  }
`
export const StyledArticleRightColumn = styled.div`
  position: absolute;
  top: 0;
  right: 1rem;
  display: none;
  width: var(--author-width);
  height: 100%;
  ${MediaQueries.mbUp} {
    display: flex;
    flex-direction: column;
  }
  .article-desktop-ad-container {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    padding: 2rem 0;
    .article-desktop-ad-wrapper {
      flex: 1;
      padding: 1rem 0;
      .article-desktop-ad {
        position: sticky;
        top: 105px;
      }
    }
  }
`
export const StyledArticleAuthorDesktop = styled.div`
  width: 100%;
  img {
    width: var(--author-avatar-width);
    height: var(--author-avatar-width);
  }
`
export const StyledArticle = styled.div`
  width: 100%;
  scroll-margin-top: 80px;
  ${MediaQueries.mbUp} {
    width: calc(100% - var(--author-width) - 3em);
  }
  hr {
    border: solid 0.5px ${(props: ThemeProps) => props.theme.colors.neutral100};
  }
  .article-opening {
    margin-bottom: 1.5em;
  }

  .article-ad-container {
    position: relative;
    z-index: ${Z_INDEX.articleAdContainer};
    text-align: center;
    iframe {
      margin-bottom: 1rem;
    }
    .article-ad {
      display: flex;
      justify-content: center;
    }

    &[data-is-amp] {
      display: flex;
      justify-content: center;
    }

    ${MediaQueries.mbUp} {
      .article-ad {
        display: none;
        /* position: absolute;
        left: calc(100% + 2rem);
        max-width: calc(var(--author-width) + 1rem);
        overflow: hidden; */
      }
      /* &.article-near-end-ads {
        .article-ad {
          top: -320px;
        }
      } */
      &.ad-avoid-bottom {
        top: -150px;
      }
    }
  }
`
export const StyledContentWrapper = styled.div`
  width: 100%;
  padding: 2rem 0;

  &[data-is-amp='true'] {
    padding: 0;
  }
`

export const StyledArticleCover = styled.div`
  position: relative;
  height: 40vh;
  min-height: 320px;
  max-height: 500px;
  margin-right: -1rem;
  margin-left: -1rem;
  background-color: ${(props: ThemeProps) => props.theme.colors.neutral50};
  ${MediaQueries.mbUp} {
    margin-right: 0;
    margin-left: 0;
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }

  amp-img {
    img {
      object-fit: cover;
    }
  }

  &[data-is-amp='true'] {
    height: 100%;
    min-height: unset;

    & + .article-content-wrapper {
      padding-top: 0px;
      margin-top: 16px;
    }
  }

  .ad-image-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    .ad-image {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 100%;
      overflow: hidden;
      transform: translateX(-50%);
    }
  }
`

export const StyledArticleBottomContainer = styled.div`
  padding: 0 0 1rem 0;
  background: white;

  &[data-is-amp='true'] {
    padding: 0;
    margin-top: 21px;

    .indexstyled__StyledDivider-sglbkl-8:last-child {
      display: none;
    }
  }
`

export const StyledArticleContentWrapper = styled(StyledContentWrapper)`
  ${TableStyle}
  &.disclaimer {
    padding-top: 0;
    padding-bottom: 0;
  }

  position: relative;
  padding: 1em 0 0;
  line-height: 1.7;
  overflow-wrap: break-word;

  white-space: pre-line;

  &[data-size='small'] {
    font-size: 14px;
    /* ${MediaQueries.mbUp} {
      font-size: 18px;
    } */
  }
  &[data-size='medium'] {
    font-size: 16px;
    /* ${MediaQueries.mbUp} {
      font-size: 22px;
    } */
  }
  &[data-size='large'] {
    font-size: 18px;
    /* ${MediaQueries.mbUp} {
      font-size: 27px;
    } */
  }

  ${MediaQueries.mbUp} {
    font-size: 18px;
  }
  /* font-size */

  * {
    max-width: 100%;
  }

  sup {
    position: relative;
    bottom: 0.7em;
    font-size: 0.7em;
    line-height: 0;
    vertical-align: baseline;
  }

  input {
    background: white;
  }

  & > {
    p,
    ul,
    form {
      &:not(:last-child) {
        margin-bottom: 1.6em;
      }
    }

    h2 {
      margin-bottom: 1em;
      font-size: 1.5em;
    }
    h3 {
      margin-bottom: 0.9em;
      font-size: 1.4em;
    }
    h4 {
      margin-bottom: 0.8em;
      font-size: 1.3em;
    }
    h5 {
      margin-bottom: 0.7em;
      font-size: 1.2em;
    }
  }

  h1 *,
  h2 *,
  h3 *,
  h4 *,
  h5 *,
  h6 * {
    font-size: inherit;
    font-weight: inherit;
  }

  img {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
    ${MediaQueries.mbDown} {
      width: calc(100% + 2rem);
      margin-right: -1rem;
      margin-left: -1rem;
      max-width: unset;
    }
  }

  figcaption {
    margin-top: 0.5em;
    margin-bottom: 1.5em;
    color: ${(props: ThemeProps) => props.theme.colors.gray500};
    font-size: 0.8em;
    text-align: center;
  }

  div.article-image-alt {
    margin-top: -1.5em;
    margin-bottom: 2em;
    color: ${(props: ThemeProps) => props.theme.colors.gray500};
    font-size: 0.8em;
    text-align: center;
  }

  ul {
    padding-left: 1rem;
    margin-bottom: 1em;
    list-style: inside;
    white-space: normal;
  }

  li {
    position: relative;
    padding-left: 2em;
    margin-bottom: 0.4em;
    list-style-type: none;
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      margin-left: 0.5em;
      color: ${(props: ThemeProps) => props.theme.colors.primaryBase};
      content: '•';
      font-size: 1em;
    }
    *:first-child {
      display: initial;
    }
  }

  ol {
    margin-bottom: 1em;
    list-style: decimal;
    li {
      padding-left: unset;
      margin-left: 2em;
      list-style-type: unset;
      &:before {
        display: none;
      }
      &::marker {
        font-size: 1.1em;
        font-weight: bold;
      }
    }
  }

  form {
    display: flex;
    align-items: center;
  }

  /* Colors */

  & > {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      color: ${(props: ThemeProps) => props.theme.colors.gray800};
    }

    a {
      color: ${(props: ThemeProps) => props.theme.colors.primaryBase};
      text-decoration: none;
    }
  }

  /* Scroll offset */
  h2[id],
  h3[id] {
    scroll-margin: 70px;
  }
  /* Key take-away */

  .key-takaway-logo-wrapper {
    display: none;
  }

  .unique-content {
    .content-key-takeaways {
      padding: 16px;
      margin: 24px 0;
      background-color: #fff9eb;
      background-size: 100%;
      border-radius: 6px;

      .content {
        background-origin: content-box;
        > h2,
        > h2 * {
          margin-bottom: 0;
          color: #284a75 !important;
        }

        span,
        p,
        ul {
          margin: 0;
          font-weight: normal;
          font-size: 14px;
          line-height: 24px;
        }
      }
      .title {
        margin-bottom: 16px;
        border-bottom: 2px solid #fb8c00;
        padding-bottom: 8px;
        h3 {
          margin-bottom: 0;
          color: #fb8c00 !important;
          font-weight: 600;
          font-size: 18px;
          line-height: 32px;
        }
      }
    }

    /* Quotation */

    .content-quotation {
      position: relative;
      padding: 40px 24px 24px 24px;
      margin: 48px 0 24px 0;

      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.06);
      border-radius: 16px;
      border: 1px solid #f3f3f3;
      box-sizing: border-box;

      &::before {
        position: absolute;
        top: -24px;
        left: 24px;
        display: block;
        width: 48px;
        height: 48px;
        content: url('/svg/quote.svg');
      }

      .title {
        margin: 16px 0 0 0;
        display: flex;
        align-items: center;
        gap: 8px;
        h3 {
          margin: 0;
          color: #9495a0 !important;
          font-weight: normal;
          font-size: 14px !important;
          line-height: 24px;
        }
      }

      .content {
        padding: 0 0 16px 0;
        font-weight: 600;
        font-size: 16px;
        line-height: 26px;
        letter-spacing: -0.2px;
        font-family: Inter;
        border-bottom: 2px solid #f3f3f3;
      }
      .content * {
        font-weight: 600 !important;
        font-size: 16px;
        line-height: 26px;
      }
    }

    /* Recommendation section */
    .content-recommendation {
      position: relative;
      padding: 16px;
      margin: 24px 0;
      background-color: #f2fcf7;
      border-radius: 6px;

      .title {
        display: flex;
        align-items: center;
        border-bottom: 2px solid #5ec08f;
        padding-bottom: 8px;
        h3 {
          margin-bottom: 0;
          color: #5ec08f !important;
          font-weight: 600;
          font-size: 18px;
          line-height: 32px;
        }
      }

      .content {
        margin-top: 16px;
        font-size: 14px;
        line-height: 28px;

        li {
          position: relative;
          padding-left: 32px;
          margin-bottom: 16px;
          font-weight: normal;
          font-size: 14px;
          line-height: 24px;
          &:before {
            position: absolute;
            top: 0;
            left: 0;
            color: #5ec08f;
            content: '•';
            font-size: 12px;
          }
          *:first-child {
            display: initial;
          }
        }
      }
    }

    /* Article summary */
    .content-summary {
      padding: 16px 16px 24px 16px;
      margin: 24px 0;
      background-color: #e0e9fb;
      border-radius: 8px;

      .title {
        border-bottom: 2px solid #2661ad;
        margin-bottom: 16px;
        padding-bottom: 8px;
        h3 {
          margin-bottom: 0;
          color: #2661ad !important;
          font-weight: 600;
          font-size: 18px;
          line-height: 32px;
        }
      }

      .content {
        > p,
        h3 {
          margin-bottom: 8px;
        }
        font-size: 14px;
        line-height: 28px;

        ul {
          margin: 0;
          padding: 0;
        }

        li {
          position: relative;
          ${MediaQueries.mbUp} {
            padding-left: 48px;
          }

          ${MediaQueries.mbDown} {
            padding-left: 32px;
          }
          margin-bottom: 8px;
          font-size: 14px;
          line-height: 24px;
          &:before {
            position: absolute;
            top: 0;
            left: 0;
            color: #2661ad;
            content: '•';
            font-size: 12px;
          }
          *:first-child {
            display: initial;
          }
        }
      }
    }
  }
`

export const StyledDividerUnion = styled.div`
  height: 24px;
  margin-bottom: 2rem;
  background-image: url('/svg/union.svg');
  background-size: contain;
`

export const StyledDivider = styled(Divider)`
  ${MediaQueries.mbDown} {
    width: calc(100% + 2rem);
    margin-right: -1rem;
    margin-left: -1rem;
  }
`
export const StyledEmbedHealtool = styled.div`
  padding: 24px 0;
  ${MediaQueries.mbDown} {
    padding: 16px 0;
  }
`

export const StyledEmbedSpotlight = styled.div`
  img {
    border-radius: 6px;
  }
  margin-bottom: 32px;
`

export const StyledVideoWrapper = styled.div`
  margin: 2rem 0;
`

export const StyledVideoList = styled(VideoList)`
  ${MediaQueries.mbDown} {
    margin-inline: 0;
  }
`
